<template>
  <modal
    v-slot="{ data }"
    name="selectFavoriteStore"
    modal-style="compact"
  >
    <select-favorite-store v-bind="data" />
  </modal>

</template>


<script>
  import SelectFavoriteStore from './select-favorite-store/index.vue';


  export default {
    name: 'SelectFavoriteStoreModal',

    components: {
      SelectFavoriteStore
    }
  };
</script>
